import TicketsPanel from "@/components/TicketsPanel";
export default function Tickets() {
  return <TicketsPanel isClient={false} />;
}
